import { render } from "./PPSSetup.vue?vue&type=template&id=6835b024"
import script from "./PPSSetup.vue?vue&type=script&lang=js"
export * from "./PPSSetup.vue?vue&type=script&lang=js"

import "./PPSSetup.vue?vue&type=style&index=0&id=6835b024&lang=css"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__